import emptyInnerHTML from '@/common/helpers/empty-inner-html';

const joinDelimiter = ', ';

/**
 * Get the values of the cell. Always returned as an array.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @returns {Array}
 */
function getCellValues({cachedColumn, rowData}) {
    const resolveValue = () => {
        if (cachedColumn.field.includes('.')) {
            const value = cachedColumn.field.split('.');
            return value.reduce(
                (r, v) => (r !== undefined && r !== null ? r[v] : null),
                // eslint-disable-next-line no-underscore-dangle
                cachedColumn.expand ? rowData.fields._embedded : rowData.fields,
            );
        }
        return rowData.fields[cachedColumn.field];
    };

    const cellValue = cachedColumn.value
        ? cachedColumn.value.call(null, rowData.fields)
        : resolveValue();
    if (cellValue === null || cellValue === undefined || String(cellValue).trim() === '') {
        return [];
    }
    if (!Array.isArray(cellValue)) {
        return [cellValue];
    }
    return cellValue;
}

/**
 * Separate an array of elements with element delimiters.
 * @param {Array} values
 * @param {Function} createElement
 * @param {String} delimiter
 */
function separateChildren({values, createElement, delimiter = joinDelimiter}) {
    const delimiterEl = values.length > 1 ? createElement('span', delimiter) : '';
    return values.reduce((result, node, index, original) => (index < original.length - 1
        ? result.concat(node, delimiterEl)
        : result.concat(node)), []);
}

function getEmptyCellElement(createElement) {
    return createElement(
        'span',
        {
            domProps: {
                innerHTML: emptyInnerHTML,
            },
        },
    );
}

export default {
    getCellValues,
    separateChildren,
    getEmptyCellElement,
    joinDelimiter,
    emptyInnerHTML,
};
